<template>
    <div id="header">
        <div class="header-content">
            <section class="header-left logo-wrapper">
                <router-link to="/">
                    <img
                        src="/images/svg/tripwards-logo.svg"
                        alt="Tripwards Logo"
                    />
                </router-link>
            </section>
            <section v-if="userStore.isLoggedIn" class="header-right">
                <router-link
                    to="/users/notifications"
                    class="header-notifications"
                    :title="
                        hasUnreadNotifications
                            ? 'Unread notifications'
                            : 'Notifications'
                    "
                >
                    <span
                        class="icon icon-notifications material-symbols-outlined"
                        :class="{ unread: hasUnreadNotifications }"
                    >
                        {{
                            hasUnreadNotifications
                                ? "notifications_active"
                                : "notifications"
                        }}
                    </span>
                    <span
                        v-if="hasUnreadNotifications"
                        class="notification-dot"
                    ></span>
                </router-link>
                <div id="header-user" @click="showDropdown">
                    <span class="icon icon-person material-symbols-outlined">
                        person
                    </span>
                    <span class="name">{{ name }}</span>
                </div>
            </section>
            <section v-else class="header-right">
                <router-link id="login" to="/login">Login</router-link>
                <span class="divider">|</span>
                <router-link id="register" to="/register">Register</router-link>
            </section>
        </div>
        <div v-if="showNav" class="header-nav">
            <nav>
                <router-link to="/" class="nav-home">
                    <div>
                        <span class="icon material-symbols-outlined">home</span>
                    </div>
                </router-link>
                <router-link to="/trips" class="nav-trips">
                    <div>
                        <span class="sm-icon material-symbols-outlined">
                            travel_explore
                        </span>
                        <span class="text">Trips</span>
                    </div>
                </router-link>
                <router-link to="/bucket-lists" class="nav-bucket-lists">
                    <div>
                        <span class="sm-icon material-symbols-outlined">
                            checklist
                        </span>
                        <span class="text">Bucket lists</span>
                    </div>
                </router-link>
                <router-link to="/planning" class="nav-planning">
                    <div>
                        <span class="sm-icon material-symbols-outlined">
                            smart_toy
                        </span>
                        <span class="text">Planning</span>
                    </div>
                </router-link>
                <router-link to="/stats" class="nav-stats">
                    <div>
                        <span class="sm-icon material-symbols-outlined">
                            bar_chart
                        </span>
                        <span class="text">Stats</span>
                    </div>
                </router-link>
            </nav>
        </div>
        <NavigationDropdown
            :show="dropdown.show"
            :items="dropdown.items"
            :position="dropdown.position"
            @close="dropdown.show = false"
            @update="onUpdate"
        />
    </div>
</template>

<script>
import NavigationDropdown from "js/components/blocks/NavigationDropdown";
import _debounce from "lodash/debounce";
import { useUserStore } from "js/stores/userStore";

export default {
    name: "PageHeader",
    components: {
        NavigationDropdown,
    },
    inject: ["screenWidth"],
    props: {
        showNav: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            userStore: undefined,
            navigationStore: undefined,
            interval: null,
            prevScrollpos: 0,
            currentScrollPos: 0,
            dropdown: {
                show: false,
                items: [
                    {
                        name: "Friends",
                        url: "/users/friends",
                        id: "navigation-notifications",
                    },
                    {
                        name: "Settings",
                        url: "/settings",
                        id: "navigation-settings",
                    },
                    {
                        name: "Logout",
                        action: "logout",
                        id: "navigation-logout",
                    },
                ],
                position: 1,
            },
        };
    },
    computed: {
        name() {
            return this.userStore.user.name;
        },
        hasUnreadNotifications() {
            return this.userStore.getUnreadNotifications() > 0;
        },
    },
    created() {
        this.userStore = useUserStore();
        this.userStore.init();

        if (this.interval === null) {
            this.interval = this.userStore.setRoutine();
        }

        this.prevScrollpos = window.pageYOffset;

        window.addEventListener("scroll", this.onScroll);
    },
    beforeUnmount() {
        if (this.interval === null) {
            return;
        }
        clearInterval(this.interval);

        window.removeEventListener("scroll", this.onScroll);
    },
    methods: {
        async logout() {
            this.hideDropdown();

            if (await this.userStore.logout()) {
                window.location.href = "/login";
            }
        },
        onUpdate(action) {
            if (action === "logout") {
                this.logout();
            }
        },
        showDropdown() {
            this.dropdown.show = true;
        },
        hideDropdown() {
            this.dropdown.show = false;
        },
        onScroll: _debounce(function () {
            this.currentScrollPos = window.pageYOffset;
            const top =
                this.screenWidth > this.$breakpoint("sm") ? "-90px" : "-106px";

            if (
                this.prevScrollpos > this.currentScrollPos ||
                this.currentScrollPos < 200
            ) {
                document.getElementById("header").style.top = "0";
            } else {
                document.getElementById("header").style.top = top;
            }

            this.prevScrollpos = this.currentScrollPos;
            this.hideDropdown();
        }, 100),
    },
};
</script>
